export default __webpack_public_path__ + "static/media/theater-curtains.ee515667.svg";